import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-footer" }
const _hoisted_2 = { class: "copyright" }

import Logo from "@/components/Application/AppLogo.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createVNode(Logo),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "version" }, [
      _createElementVNode("b", null, "Version"),
      _createTextVNode(" 1.0.0")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("strong", null, [
        _createTextVNode("Copyright © 2015 - " + _toDisplayString(new Date().getFullYear()) + " ", 1),
        _cache[0] || (_cache[0] = _createElementVNode("a", { href: "https://www.zeroquest.kr/" }, "For ZeroQuest", -1)),
        _cache[1] || (_cache[1] = _createTextVNode(".", -1))
      ]),
      _cache[2] || (_cache[2] = _createTextVNode(" All rights reserved. ", -1))
    ])
  ]))
}
}

})